<template>
  <div>
    <el-dialog top="40vh" :visible.sync="show" :show-close="false" :append-to-body="true" :close-on-click-modal="false"
      width="433px">
      <div class="top-con a-center" slot="title">
        <div class="left">
          <img src="@/assets/notice@2x.png" style="width: 24px;height: 24px;margin-right: 14px;" />
          <div class="title">{{ title }}</div>
        </div>
      </div>
      <div class="lh--32 fs--20">
        {{ tip }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('close')">取消</el-button>
        <el-button :type="btnType" @click="$emit('confirm')">{{ okText }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '确认要删除这条信息吗？',
    },
    tip: {
      type: String,
      default: '删除后信息将无法找回',
    },
    okText: {
      type: String,
      default: '确认',
    },
    btnType: {
      type: String,
      default: 'danger',
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {},
};
</script>
<style scoped lang="less">
.left {
  display: flex;
}

::v-deep .el-dialog {
  border-radius: 12px;

  .el-dialog__header {
    padding-top: 28px;
    padding-right: 27px;
    padding-left: 34px;
    padding-bottom: 11px;
  }

  .el-dialog__body {
    border-top: unset;
    padding: unset;
    padding-left: 73px;
    padding-right: 20px;
  }

  .el-dialog__footer {
    border-top: unset;
    padding-top: 18px;
    padding-right: 27px;
    padding-bottom: 29px;
  }
}

.bgcolor1 {
  background: rgba(22, 119, 255, 1);
}

.top-con {
  display: flex;
  justify-content: space-between;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
    margin-bottom: 13px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>